import React, { useState, useEffect } from 'react'
import AdminHomeHelper from '../../Components/AdminHomeHelper'


const AdminHostel = () => {

    
    return (
        <div>
           <div className="container-fluid p-0">
          <div className="d-flex">
              <div className="print-helper">
                <AdminHomeHelper />
              </div>
              <div className="mx-1 w-100 ">
                <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                  <h3> <img src="/logo192.png" width={'50px'} alt="" /> HOSTEL</h3>
                  <button onClick={()=> window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                </div>
                            </div>
                            </div>
                        </div>
                    </div>
    )
}

export default AdminHostel
